import React, { useState, useEffect } from 'react';
import { Globe, Users, User, ArrowLeft, Check } from 'lucide-react';
import { fetchUserSettings, editUserPrivacy } from "../../apiservices/ApiService";

import { useNavigate } from "react-router-dom";

const Fsn41PrivacySettings = () => {
  const [settings, setSettings] = useState({
    logFood: { public: false, city: false, private: true },
    activities: { public: false, city: false, private: true },
    //karmaContribution: { global: true, group: false, individual: false },    
    dailyTargetCompletion: { public: false, city: true, private: false },
  });
  var [womenCareCard, setWomenCareCard] = useState(false);
  const [isSaving, setSaving] = useState(false);
  const [isModified, setIsModified] = useState(false);
  const navigate = useNavigate();


  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const response = await fetchUserSettings();

        console.log(response);
        setIntialvalues("logFood", response.logFood)
        setIntialvalues("activities", response.activities)
        setIntialvalues("dailyTargetCompletion", response.dailyTargetCompletion)
        setWomenCareCard(response.hideWomenCareCard === "Y" ? true : false);
        console.log(womenCareCard)
      } catch (error) {
        console.error("Error fetching user info:", error);
      }
    };

    fetchUserInfo();
  }, []);

  const setIntialvalues = (setting, type) => {
    setSettings(prev => ({
      ...prev,
      [setting]: {
        global: type === 'public',
        group: type === 'city',
        individual: type === 'private'
      }
    }));
  };
  const handleIconClick = (setting, type) => {
    setIsModified(true);
    setSettings(prev => ({
      ...prev,
      [setting]: {
        global: type === 'public',
        group: type === 'city',
        individual: type === 'private'
      }

    }));
  };

  const handleWomenCareCardToggle = () => {
    setIsModified(true);
    setWomenCareCard(!womenCareCard);
  };

  const handleSave = async () => {
    setSaving(true);

    try {
      // Process the settings into the desired payload structure
      const payload = {
        logFood: getSelectedOption(settings.logFood),
        activities: getSelectedOption(settings.activities),
        dailyTargetCompletion: getSelectedOption(settings.dailyTargetCompletion),
        hideWomenCareCard: womenCareCard ? "Y" : "N",
      };
      const responce = editUserPrivacy(payload)
      console.log('Payload to send:', payload);
      console.log('responce:', responce);



      setIsModified(false);
    } catch (error) {
      console.error('Error saving settings:', error);
    } finally {
      setSaving(false);
    }
  };

  // Helper function to determine which option is selected
  const getSelectedOption = (setting) => {
    if (setting.global) return 'public';
    if (setting.group) return 'city';
    if (setting.individual) return 'private';
    return null
  };


  const formatTitle = (key) => {
    return key.replace(/([A-Z])/g, ' $1')
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  const styles = {
    container: {
      backgroundColor: '#f5f5f5',
      minHeight: '100vh',
      fontFamily: 'Arial, sans-serif'
    },
    header: {
      height: '56px',
      backgroundColor: 'white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 16px',
      borderBottom: '1px solid #e0e0e0',
      position: 'relative'
    },
    title: {
      position: 'absolute',
      left: '50%',
      transform: 'translateX(-50%)',
      margin: 0,
      fontSize: '20px',
      fontWeight: 'normal'
    },
    iconButton: {
      background: 'none',
      border: 'none',
      padding: '8px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    content: {
      padding: '16px'
    },
    subtitle: {
      color: '#FFC107',
      fontSize: '16px',
      marginBottom: '24px',
      fontWeight: 'normal'
    },
    card: {
      backgroundColor: 'white',
      borderRadius: '4px',
      padding: '16px'
    },
    settingRow: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '24px'
    },
    settingLabel: {
      fontSize: '16px'
    },
    iconGroup: {
      display: 'flex',
      gap: '16px'
    },
    toggleContainer: {
      borderTop: '1px solid #e0e0e0',
      paddingTop: '16px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    toggleSwitch: {
      width: '52px',
      height: '32px',
      backgroundColor: props => props.active ? '#4CAF50' : '#e0e0e0',
      borderRadius: '16px',
      position: 'relative',
      cursor: 'pointer',
      border: 'none',
      transition: 'background-color 0.3s',
      padding: 0
    },
    toggleHandle: {
      width: '28px',
      height: '28px',
      backgroundColor: 'white',
      borderRadius: '50%',
      position: 'absolute',
      top: '2px',
      left: '2px',
      transition: 'transform 0.3s',
      boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
      transform: props => props.active ? 'translateX(20px)' : 'translateX(0)'
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <button style={styles.iconButton} onClick={() => navigate(-1)}>
          <ArrowLeft size={24} />
        </button>
        <h1 style={styles.title}>PRIVACY</h1>
        <button
          onClick={handleSave}
          disabled={!isModified || isSaving}
          style={{
            ...styles.iconButton,
            color: isModified ? '#4CAF50' : '#BDBDBD'

          }}
        >
          <Check size={24} />
        </button>
      </div>

      <div style={styles.content}>
        <h2 style={styles.subtitle}>Who Would See Your Future Posts?</h2>

        <div style={styles.card}>
          {Object.entries(settings).filter(([key]) => key && settings[key]).map(([key, value]) => (
            <div key={key} style={styles.settingRow}>
              <span style={styles.settingLabel}>
                {formatTitle(key)}
              </span>
              <div style={styles.iconGroup}>
                <button
                  onClick={() => handleIconClick(key, 'public')}
                  style={{
                    ...styles.iconButton,
                    color: value.global ? '#2196F3' : '#BDBDBD'
                  }}
                >
                  <Globe size={20} />
                </button>
                <button
                  onClick={() => handleIconClick(key, 'city')}
                  style={{
                    ...styles.iconButton,
                    color: value.group ? '#2196F3' : '#BDBDBD'
                  }}
                >
                  <Users size={20} />
                </button>
                <button
                  onClick={() => handleIconClick(key, 'private')}
                  style={{
                    ...styles.iconButton,
                    color: value.individual ? '#2196F3' : '#BDBDBD'
                  }}
                >
                  <User size={20} />
                </button>
              </div>
            </div>
          ))}

          <div style={styles.toggleContainer}>
            <span style={styles.settingLabel}>Hide Women Care Card</span>
            <button
              onClick={handleWomenCareCardToggle}
              style={{
                ...styles.toggleSwitch,
                backgroundColor: womenCareCard ? '#4CAF50' : '#e0e0e0'
              }}
            >
              <div style={{
                ...styles.toggleHandle,
                transform: womenCareCard ? 'translateX(20px)' : 'translateX(0)'
              }} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Fsn41PrivacySettings;